/**
 * api-文章栏目
 */
import { post } from '@/utils/http'
// 获取文章栏目列表
export const apiGetCategorys = p => post('/article/getCategorys.do', p)
// 添加文章栏目分类
export const apiAddCategorys = p => post('/article/addCategorys.do', p)
// 编辑文章栏目分类
export const apiEditCategorys = p => post('/article/editCategorys.do', p)
// 删除文章栏目分类
export const apiDelCategorys = p => post('/article/delCategorys.do', p)
// 获取健康在线文章列表
export const apiGetArticless = p => post('/article/getArticles.do', p)
// 新增健康在线类-文章
export const apiAddArticles = p => post('/article/addArticles.do', p)
// 删除健康在线类-文章
export const apiDelArticles = p => post('/article/delArticles.do', p)
// 修改健康在线-文章
export const apiEditArticles = p => post('/article/editArticles.do', p)
// 资讯动态列表获取
export const apiGetDynamicList = p => post('/dynamic/getDynamicList.do', p)
// 获取动态的详细信息
export const apiGetDynamicDtl = p => post('/dynamic/getDynamicDtl.do', p)
// 新增资讯动态
export const apiAddDynamic = p => post('/dynamic/addDynamic.do', p)
// 修改动态
export const apiEditDynamic = p => post('/dynamic/editDynamic.do', p)
// 删除资讯动态
export const apiDelDynamic = p => post('/dynamic/delDynamic.do', p)
// 获取资质详情
export const apiGetSptitude = p => post('/aptitude/getSptitude.do', p)
// 资质列表
export const apiGetSptitudeList = p => post('/aptitude/getSptitudeList.do', p)
// 新增公司资质
export const apiAddSptitude = p => post('/aptitude/addSptitude.do', p)
// 删除公司资质
export const apiDelAptitude = p => post('/aptitude/delAptitude.do', p)
// 修改公司资质
export const apiEditAptitude = p => post('/aptitude/editAptitude.do', p)
